<div class="wrapper">
  <div class="action-buttons-container">
    <!-- Below div should visible only in dev environment so should be commented for UAT and Prod -->
    <!-- <div class="refresh-status" *ngIf="!environment.production" [ngClass]="refreshMode">
      {{ refreshStatusLabel }}
    </div> -->
    <div class="action-buttons">
      <div class="btn-group">
        <button type="button" class="btn btn-primary saveBtn" data-bs-toggle="modal" data-bs-target="#bookmarkModal"
          aria-expanded="false" (click)="ontoggleBookmarkSidenav()">
          <i class="fa fa-bookmark" style="margin-right: 6px;" aria-hidden="true"></i>
        </button>
      </div>
      <div mdbDropdown class="btn-group">        
        <button
          type="button"
          class="btn btn-primary dropdown-toggle exportDropdown"
          mdbDropdownToggle
          aria-expanded="false"
        >Export to    
        </button>
        <ul mdbDropdownMenu class="dropdown-menu">
          <li>
            <a class="dropdown-item" [class.disabled]="true" (click)="onExportOptionChange('closer_json')">Closer
              JSON</a>
          </li>
          <li>
            <a class="dropdown-item" [class.disabled]="true" (click)="onExportOptionChange('fannie_mae_xml')">Fannie Mae
              XML</a>
          </li>
          <li>
            <a class="dropdown-item" (click)="onExportOptionChange('cppib')">CPPIB</a>
          </li>
           <li>
            <a class="dropdown-item" (click)="onExportOptionChange('buds')">BRAVE</a>
          </li>
          <li>
            <a class="dropdown-item" (click)="onExportOptionChange('excel')">Excel</a>
          </li>
          <li>
            <a class="dropdown-item" [class.disabled]="true"
              (click)="disabled ? $event.preventDefault() : onExportOptionChange('argus')"
              [style.pointer-events]="disabled ? 'none' : 'auto'">
              Argus
            </a>
          </li>
        </ul>
      </div>
      <div mdbDropdown class="btn-group">
        <button type="button" class="btn btn-primary dropdown-toggle exportDropdown" mdbDropdownToggle
          aria-expanded="false" [disabled]="!canApproveorReject()">
          Ready for Client
        </button>
        <ul mdbDropdownMenu class="dropdown-menu">
          <li>
            <a class="dropdown-item" (click)="approveSelected()">Yes</a>
          </li>
          <li>
            <a class="dropdown-item" (click)="rejectSelected()">No</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <app-save-modal-popup #approvalModal (confirmAction)="handleModalAction($event)"></app-save-modal-popup>
  <app-confirm-dialog #confirmDialog></app-confirm-dialog>

  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav #sidenav mode="side" position="end" [(opened)]="isBookmarksPanelOpen" class="bookmarks-panel">
      <app-bookmarks (loadBookmarkInGrid) = "loadBookmark()"></app-bookmarks>
    </mat-sidenav>
    <mat-sidenav-content class="grid-content">
      <div>
        <ag-grid-angular class="grid" [theme]="theme" (gridReady)="onGridReady($event)" [columnDefs]="columnDefs" [initialState]="initialState"
          [rowClassRules]="rowClassRules" [rowData]="rowData" [defaultColDef]="defaultColDef" [rowHeight]="rowHeight"
          [pagination]="pagination" [paginationPageSize]="paginationPageSize" (stateUpdated)="onStateUpdated()"
          [paginationPageSizeSelector]="paginationPageSizeSelector" [quickFilterText]="quickFilterText"
          [detailRowAutoHeight]="detailRowAutoHeight" [enableRangeSelection]="enableRangeSelection" [excelStyles]="excelStyles"
          [enableCharts]="enableCharts" [rowSelection]="rowSelection" [rowMultiSelectWithClick]="true" [defaultExcelExportParams]="defaultExcelExportParams"
          [rowGroupPanelShow]="rowGroupPanelShow" [suppressAggFuncInHeader]="suppressAggFuncInHeader"  [suppressDragLeaveHidesColumns]="true"
          [groupDefaultExpanded]="groupDefaultExpanded" [sideBar]="sidebar" [rowHeight]="rowHeight" [loading]="!dataLoaded" [getRowId]="getRowId"
          (selectionChanged)="onSelectionChanged()" [enableAdvancedFilter]="enableAdvancedFilter">
        </ag-grid-angular>
        <div class="last-refreshed">
          <span>Last Refreshed At: {{ lastRefreshedAt }}</span>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>